import {ButtonLink} from '@modifi/ui'
import styled from 'styled-components'

export const StyledButtonLink = styled(ButtonLink)`
  div {
    font-size: 12px;
  }
`
